import React from 'react'
import { useNavigate } from 'react-router-dom'
import VisibilityIcon from '@mui/icons-material/Visibility'
import getButtonCell from 'components/generic/datagrid/cells/ButtonCell'
import DataGridWithSearch from './DataGridWithSearch'

const getColumns = navigate => [
  {
    field: 'name',
    headerName: 'Commodities',
    flex: 1,
  },
  {
    field: 'wip',
    headerName: 'WIP',
    headerAlign: 'right',
    align: 'right',
    renderCell: params => params?.row?.wipFormatted,
    flex: 1,
  },
  {
    field: 'finishedGoods',
    headerName: 'Finished Goods',
    headerAlign: 'right',
    align: 'right',
    renderCell: params => params?.row?.finishedGoodsFormatted,
    flex: 1,
  },
  {
    field: 'total',
    headerName: 'Total',
    headerAlign: 'right',
    align: 'right',
    renderCell: params => params?.row?.totalFormatted,
    flex: 1,
  },
  {
    field: 'averageCost',
    headerName: 'Avg Cost',
    headerAlign: 'right',
    align: 'right',
    renderCell: params => params?.row?.averageCostFormatted,
    flex: 1,
  },
  {
    field: 'value',
    headerName: 'Value',
    headerAlign: 'right',
    align: 'right',
    renderCell: params => params?.row?.valueFormatted,
    flex: 1,
  },
  {
    field: 'view',
    headerName: 'Actions',
    type: 'actions',
    width: 150,
    renderCell: params => getButtonCell(params, 'View', <VisibilityIcon />, () => navigate(params.row?.id)),
  },
]

const InventoryCommodityGrid = props => {
  const navigate = useNavigate()
  return <DataGridWithSearch {...props} columns={getColumns(navigate)} />
}

InventoryCommodityGrid.propTypes = DataGridWithSearch.propTypes

InventoryCommodityGrid.defaultProps = DataGridWithSearch.defaultProps

export default InventoryCommodityGrid
